import { createFeatureSelector, createSelector } from '@ngrx/store';
import { Params } from "@angular/router";
import { CustomerSchedulingState } from '.';
import { selectMergedRouteParams, selectQueryParams } from '../router/selectors';

export const selectCustomerScheduling = createFeatureSelector<CustomerSchedulingState>('customerScheduling');

export const selectAreaPreference = createSelector(selectCustomerScheduling, state => state.preferences.areas);
export const selectAreaPreferenceLoading = createSelector(selectCustomerScheduling, state => state.preferences.loading);
export const selectScheduledDates = createSelector(selectCustomerScheduling, state => state.scheduledDates);
export const selectExtraAuditRequesting = createSelector(selectCustomerScheduling, state => state.requestingAudit);
export const selectExtraAuditRequestedSuccessfully = createSelector(selectCustomerScheduling, state => state.requestedSuccessfully);

export const selectAreaId = createSelector(selectMergedRouteParams, selectQueryParams, (params: Params | undefined, query: Params | undefined) =>
  params && 'areaId' in params ? +params.areaId : 'areaId' in query ? +query.areaId : null,
);
